<button
    mat-stroked-button
    [matTooltip]="siteConfig.data.name"
    matTooltipPosition="right"
    (click)="clickHandler(siteConfig.client_id)"
>
    @if (siteConfig.thumbnail) {
        <img src="{{ siteConfig.thumbnail }}" />
    } @else {
        <span class="name-letter">{{ siteConfig.data.name.charAt(0) }}</span>
    }
</button>
